import {
	Divider,
	MobileMenu as MobileMenuComponent,
	MobileMenuControlButton,
	NavBar,
	NavBarItem,
	Text,
} from '@audio-network/componentlibrary'

import Link from 'next/link'
import MobileMenuProps from './MobileMenu.types'
import React from 'react'
import regionalSites from '@/constants/regionalSites'
import { sendAnalytics } from '@audio-network/analytics'
import { useSession } from '@/context/Session'
import { useTranslation } from 'next-i18next'

const MobileMenu = ({ showSoundEffects }: MobileMenuProps): JSX.Element => {
	const { user } = useSession()
	const { t } = useTranslation(['navigation'])

	const handleClick = (noun: string): void => {
		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	return (
		<>
			<MobileMenuControlButton aria-label="Open menu" />
			<MobileMenuComponent id="mobile-menu">
				<NavBar>
					<Link
						href="/track/searchkeyword"
						legacyBehavior
						passHref
						locale={false}
					>
						<NavBarItem
							content={showSoundEffects ? t('music') : t('search')}
							onClick={() => handleClick('Search')}
						/>
					</Link>
					<Link href="/playlist-hub" legacyBehavior passHref locale={false}>
						<NavBarItem
							content={t('playlists')}
							href="/playlist-hub"
							onClick={() => handleClick('Playlists')}
						/>
					</Link>
					<Link href="/albums" legacyBehavior passHref locale={false}>
						<NavBarItem
							content={t('albums')}
							href="/albums"
							onClick={() => handleClick('Albums')}
						/>
					</Link>
					{/* Collections is not a Music App page */}
					<NavBarItem
						content={t('collections')}
						href="/collections"
						onClick={() => handleClick('Collections')}
					/>
					{showSoundEffects && (
						<Link href="/sound-effects" legacyBehavior passHref locale={false}>
							<NavBarItem
								content={t('sound-effects')}
								onClick={() => handleClick('Sound Effects')}
							/>
						</Link>
					)}
				</NavBar>
				<Divider />
				{user && (
					<>
						<NavBar>
							<Link href={'/favourites'} legacyBehavior passHref>
								<NavBarItem
									content={t('favourites')}
									onClick={() => handleClick('Favourites')}
								/>
							</Link>
							<Link href={'/project/all'} legacyBehavior passHref>
								<NavBarItem
									content={t('projects')}
									onClick={() => handleClick('Projects')}
								/>
							</Link>
						</NavBar>
						<Divider />
					</>
				)}
				<NavBar>
					<NavBarItem
						content={t('contact-us')}
						href="/contact"
						target="_blank"
						onClick={() => handleClick('Contact us')}
					/>
					<NavBarItem
						content={t('blog')}
						href="/blog"
						target="_blank"
						onClick={() => handleClick('Blog')}
					/>
					<NavBarItem
						content={t('privacy-and-cookies')}
						href="/privacy"
						target="_blank"
						onClick={() => handleClick('Privacy')}
					/>
					<NavBarItem
						content={t('terms')}
						href="/terms"
						target="_blank"
						onClick={() => handleClick('Terms')}
					/>
				</NavBar>
				<Divider />
				<NavBar>
					{Object.entries(regionalSites).map(([key, value]) => (
						<NavBarItem
							key={key}
							content={
								<Text>
									{value.language}
									<Text color="textSecondary" display="block" variant="bodyS">
										{value.region}
									</Text>
								</Text>
							}
							href={value.href}
							aria-label={value.label ?? null}
							// Currently no analytics for regional sites?
						/>
					))}
				</NavBar>
			</MobileMenuComponent>
		</>
	)
}

export default MobileMenu
